<!-- im社群营销系统 -->
<template>
  <div class="warp">
    <div class="knowledgePayBanner">
      <p>绿茶IM社群营销系统</p>
      <span>
        兼容telegram的
        <br />IM社群工具
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="marketing1">
      <div
        class="topTip"
      >绿茶IM社群营销系统，以社交为基础，兼容电报群(telegram).是连接企业和用户的信息共享和交流平台。可轻松开启沟通社群，并提供一系列社群营销管理工具，助力企业实现社群自动化、高效管理，大幅度降低运营成本，推动社区发展。</div>
      <div class="title">特色功能</div>
      <ul class="list1">
        <li>
          <img src="../../assets/images/icon58.png" />
          <span>红包营销</span>
          <p>可发社群红包和个人红包做裂0变推广，提高社群活跃度，打通用户资源</p>
        </li>
        <li>
          <img src="../../assets/images/icon59.png" />
          <span>社群机器人</span>
          <p>实现入群欢迎、消息群发、自动回复、定时公告、警告禁言等操作，提高社群管理效率</p>
        </li>
        <li>
          <img src="../../assets/images/icon60.png" />
          <span>社群绩效管理</span>
          <p>全方位社群数据统计，实时监测链接点击情况，帮您发现关键用户，合理分配资源</p>
        </li>
        <li>
          <img src="../../assets/images/icon61.png" />
          <span>社群裂变</span>
          <p>绑定社群从属关系，构建社群生态，实现多群的消息同步、内容共享、数据监测、高效管理</p>
        </li>
      </ul>
    </div>
    <div class="marketing1">
      <div class="title" style="padding:0 0 .2rem;margin-top:-.8rem">应用场景</div>
      <div class="item1">
        <div class="subTitle">
          <img src="../../assets/images/title1.jpg" />
        </div>
        <div class="showImg">
          <img src="../../assets/images/page36.jpg" />
        </div>
        <ul>
          <li>
            <img src="../../assets/images/icon62.png" />
            <div>
              <span>私密聊天</span>
              <p>端对端加密聊天、单聊、群聊、讨论组、支持所有 IM场景</p>
            </div>
          </li>
          <li>
            <img src="../../assets/images/icon63.png" />
            <div>
              <span>万人社群</span>
              <p>兼容电报群(telegram)，可一键加入各主流社群， 轻松打造万人超级社群</p>
            </div>
          </li>
          <li>
            <img src="../../assets/images/icon64.png" />
            <div>
              <span>隐私安全</span>
              <p>加密个人信息。所有对话和共享文件，联系时不必担心数据被拦截或窃取</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="item2">
        <div class="subTitle">
          <img src="../../assets/images/title2.jpg" />
        </div>
        <div class="dlBox">
          <dl>
            <dt>
              <img src="../../assets/images/icon65.png" />
              <span>社群引流</span>
            </dt>
            <dd>
              <i></i>
              <span>裂变海报</span>
            </dd>
            <dd>
              <i></i>
              <span>邀请有奖</span>
            </dd>
            <dd>
              <i></i>
              <span>入群有奖</span>
            </dd>
          </dl>
        </div>
        <div class="dlBox dlBox2">
          <dl>
            <dt>
              <img src="../../assets/images/icon65.png" />
              <span>社群活跃</span>
            </dt>
            <dd>
              <i></i>
              <span>红包营销</span>
            </dd>
            <dd>
              <i></i>
              <span>签到奖励</span>
            </dd>
            <dd>
              <i></i>
              <span>社群活动</span>
            </dd>
          </dl>
        </div>
        <div class="subTitle">
          <img src="../../assets/images/page37.jpg" />
        </div>
      </div>

      <div class="item3">
        <div class="subTitle">
          <img src="../../assets/images/title3.jpg" />
        </div>
        <ul>
          <li>
            <div class="t1">
              <img src="../../assets/images/icon66.png" />
              <span>日常管理</span>
              <p>
                社群机器人
                <br />自动触发，定时推送
              </p>
              <button>了解详情</button>
            </div>
            <dl class="t2">
              <dd>
                <i></i>
                <span>消息群发</span>
              </dd>
              <dd>
                <i></i>
                <span>警告禁言</span>
              </dd>
              <dd>
                <i></i>
                <span>自动回复</span>
              </dd>
              <dd>
                <i></i>
                <span>定时公告</span>
              </dd>
            </dl>
          </li>
          <li>
            <div class="t1">
              <img src="../../assets/images/icon67.png" />
              <span>绩效管理</span>
              <p>
                社群数据统计
                <br />实时监测社群动态
              </p>
              <button>了解详情</button>
            </div>
            <dl class="t2">
              <dd>
                <i></i>
                <span>入群数</span>
              </dd>
              <dd>
                <i></i>
                <span>退出数</span>
              </dd>
              <dd>
                <i></i>
                <span>发言数</span>
              </dd>
              <dd>
                <i></i>
                <span>邀请数</span>
              </dd>
            </dl>
          </li>
          <li>
            <div class="t1">
              <img src="../../assets/images/icon67.png" />
              <span>群组管理</span>
              <p>
                社群裂变
                <br />构建社群生态关系
              </p>
              <button>了解详情</button>
            </div>
            <dl class="t2">
              <dd>
                <i></i>
                <span>多群管理</span>
              </dd>
              <dd>
                <i></i>
                <span>消息同步</span>
              </dd>
              <dd>
                <i></i>
                <span>精华共享</span>
              </dd>
              <dd>
                <i></i>
                <span>数据跟踪</span>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "marketingSystem",

  data() {
    return {};
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .knowledgePayBanner {
    background: url("../../assets/images/marketingSystemBanner.jpg") no-repeat
      left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fff;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #5d3fd0;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .marketing1 {
    padding: 0.6rem 0;
    .topTip {
      padding: 0 0.35rem;
      font-size: 0.34rem;
      line-height: 0.6rem;
      color: #666;
      text-indent: 2em;
    }
    .title {
      text-align: center;
      font-size: 0.44rem;
      padding: 0.9rem 0;
    }
    .list1 {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        text-align: center;
        padding: 0 0.6rem;
        margin-bottom: 1rem;
        img {
          width: 1.5rem;
          height: 1.5rem;
        }
        span {
          font-size: 0.38rem;
          color: #333;
          display: block;
          padding: 0.1rem 0;
        }
        p {
          font-size: 0.3rem;
          color: #666;
        }
      }
    }
    .item1 {
      background-color: #fff;
      img {
        width: 100%;
      }
      ul {
        padding: 0.2rem 0.5rem 0.7rem 0.5rem;
        li {
          display: flex;
          padding: 0.3rem 0;
          img {
            width: 0.8rem;
            height: 0.8rem;
          }
          div {
            flex: 1;
            span {
              line-height: 0.8rem;
              font-size: 0.4rem;
              color: #000;
            }
            p {
              color: #999;
              font-size: 0.34rem;
            }
          }
        }
      }
    }
    .item2 {
      background-color: #eff0f2;
      padding-top: 0.9rem;
      .dlBox {
        margin: 0 0.9rem;
        background: #fff;
        border-radius: 0.2rem;
        margin-top: 0.7rem;
        overflow: hidden;
        box-shadow: 0px 6px 10px 0px rgba(56, 64, 154, 0.06);
        dt {
          font-size: 0.38rem;
          color: #fff;
          background-color: #606feb;
          line-height: 1rem;
          text-align: center;
          border-radius: 0.2rem 0.2rem 0 0;
          img {
            width: 0.8rem;
            height: 0.8rem;
          }
        }
        dd {
          float: left;
          width: 33.33333%;
          text-align: center;
          font-size: 0.34rem;
          color: #666;
          line-height: 1.4rem;
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 0.08rem;
            height: 0.08rem;
            background-color: #999;
            border-radius: 0.1rem;
            margin-left: 0.7rem;
            margin-right: 0.2rem;
          }
        }
      }
      .dlBox2 {
        dt {
          background-color: #f36b7c;
        }
      }
    }
    .item3 {
      padding: 0.9rem 0 0;
      ul{
        display: flex;
        padding: .9rem 0;
        li{
          flex: 1;
          text-align: center;
          position: relative;
          .t1{
            img{
              width: 1.5rem;
              height: 1.5rem;
            }
            span{
              font-size: .4rem;
              display: block;
              padding-bottom: .1rem;
            }
            p{
              font-size: .3rem;
              color: #666;
            }
            button{
              font-size: .32rem;
              width: 2.2rem;
              line-height: .6rem;
              border: 1px solid #616cea;
              color: #616cea;
              border-radius: .9rem;
              height: .6rem;
              margin-top: .4rem;
            }
          }
          .t2{
            background-color: #4749d4;
            width: 70%;
            text-align:center;
            border-radius: .3rem .3rem .3rem 0;
            position: absolute;
            left: 15%;
            top: 0;
            padding: .4rem 0;
            display: none;
            transition: all .1s;
            dd{
              font-size: .32rem;
              color: #fff;
              line-height: .6rem;
              i{
                width: .08rem;
                height: 0.08rem;
                border-radius: 1rem;
                background-color: #7f80e1;
                display: inline-block;
                margin-right: .1rem;
                vertical-align: middle;
              }
            }
          }
          &:hover{
            .t2{
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/marketingSystem.vue